import React, { useState } from 'react';
import Slide from './Slide';
import { SliderControl } from 'components/Slider';

import * as styles from './MobileSlider.module.scss';

export default function MobileSlider({ id, items }) {
  const [active, setActive] = useState(`${id}-1`);
  const current = getCurrentSlideNumber(active);

  const getCardId = index => {
    return `${id}-${index + 1}`;
  };

  function handleSlideChange(idNumber) {
    const updatedId = active.replace(/\d+$/, idNumber.toString());
    const scrollTarget = document.getElementById(updatedId);
    scrollTarget?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  return (
    <>
      <div className={styles.scrollWrap}>
        {items.map((project, i) => {
          const cardId = getCardId(i);

          return <Slide key={cardId} cardId={cardId} {...project} setActive={setActive} />;
        })}
      </div>
      <SliderControl
        className={styles.sliderControl}
        to={items.length}
        current={current}
        handleNext={() => handleSlideChange(current + 1)}
        handlePrev={() => handleSlideChange(current - 1)}
      />
    </>
  );
}

function getCurrentSlideNumber(slideId) {
  const digits = slideId.match(/\d+/g);
  return digits ? parseInt(digits[digits.length - 1]) : null;
}
